<template>
  <div v-if="editMode" class="message-placeholder-container">
    <div class="medium-message-placeholder">
      <iText>Article Hashtag Input Placeholder</iText>
    </div>
  </div>
  <StoryHashtagInput
    v-else
    v-model="hashtags"
    edit
    :validation="validateHashtag"
    hashtag-value-key="hashtag"
    placeholder="+ Tags"
    @submit:hashtag="addHashtags"
    @delete:hashtag="removeHashtag"
  />
</template>

<script>
import {
  ArticleEditorElementMixin,
} from "%/dynamic-component-editor/standard-elements/articles/shared/article-editor-element-mixin";
import StoryHashtagInput from "%/dynamic-component-editor/components/StoryHashtagInput.vue";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";

export default {
  name: "ArticleHashtagInput",
  components: { StoryHashtagInput },
  elementPanelSettings: {
    displayName: "Hashtag Input",
    displayIcon: "pencil",
    elementGroup: "articleElements",
    elementType: "element",
  },
  mixins: [ArticleEditorElementMixin],
  options: [
    new LayoutWidth({
      default: "hug",
    }, true),
    new LayoutHeight({
      default: "hug",
    }, true),
  ],
  methods: {
    validateHashtag(value) {
      const result = /^(#)?[a-zA-Z0-9_]+$/.test(value);
      if (!result) {
        return "Hashtag must be alphanumeric and can only contain underscores.";
      }
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
